const classes = {
  root: {
    marginTop: "64px",
    textAlign: "center",
  },
  image: {
    width: "30%",
    maxWidth: "400px",
  },
  message: {
    fontWeight: 400,
    marginBottom: "16px",
  },
  navigate_button: {
    marginTop: '24px',
    padding: '10px 40px',
    maxWidth: '300px',
  }
};

export default classes